"use strict";

function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
var __create = Object.create;
var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = function __defNormalProp(obj, key, value) {
  return key in obj ? __defProp(obj, key, {
    enumerable: true,
    configurable: true,
    writable: true,
    value: value
  }) : obj[key] = value;
};
var __spreadValues = function __spreadValues(a, b) {
  for (var prop in b || (b = {})) if (__hasOwnProp.call(b, prop)) __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols) {
    var _iterator = _createForOfIteratorHelper(__getOwnPropSymbols(b)),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var prop = _step.value;
        if (__propIsEnum.call(b, prop)) __defNormalProp(a, prop, b[prop]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }
  return a;
};
var __spreadProps = function __spreadProps(a, b) {
  return __defProps(a, __getOwnPropDescs(b));
};
var __objRest = function __objRest(source, exclude) {
  var target = {};
  for (var prop in source) if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0) target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols) {
    var _iterator2 = _createForOfIteratorHelper(__getOwnPropSymbols(source)),
      _step2;
    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var prop = _step2.value;
        if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop)) target[prop] = source[prop];
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }
  return target;
};
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};
var __copyProps = function __copyProps(to, from, except, desc) {
  if (from && typeof from === "object" || typeof from === "function") {
    var _iterator3 = _createForOfIteratorHelper(__getOwnPropNames(from)),
      _step3;
    try {
      var _loop = function _loop() {
        var key = _step3.value;
        if (!__hasOwnProp.call(to, key) && key !== except) __defProp(to, key, {
          get: function get() {
            return from[key];
          },
          enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable
        });
      };
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        _loop();
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }
  return to;
};
var __toESM = function __toESM(mod, isNodeMode, target) {
  return target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", {
    value: mod,
    enumerable: true
  }) : target, mod);
};
var __toCommonJS = function __toCommonJS(mod) {
  return __copyProps(__defProp({}, "__esModule", {
    value: true
  }), mod);
};

// src/server.ts
var server_exports = {};
__export(server_exports, {
  PlateElement: function PlateElement() {
    return _PlateElement;
  },
  PlateLeaf: function PlateLeaf() {
    return _PlateLeaf;
  },
  addSelectedRow: function addSelectedRow() {
    return _addSelectedRow;
  },
  blockSelectedIds: function blockSelectedIds() {
    return _blockSelectedIds;
  },
  createNodeHOC: function createNodeHOC() {
    return _createNodeHOC;
  },
  createNodesHOC: function createNodesHOC() {
    return _createNodesHOC;
  },
  createNodesWithHOC: function createNodesWithHOC() {
    return _createNodesWithHOC;
  },
  defaultsDeepToNodes: function defaultsDeepToNodes() {
    return _defaultsDeepToNodes;
  },
  hasBlockSelected: function hasBlockSelected() {
    return _hasBlockSelected;
  },
  isBlockSelected: function isBlockSelected() {
    return _isBlockSelected;
  },
  isType: function isType() {
    return _isType;
  },
  moveSelectionByOffset: function moveSelectionByOffset() {
    return _moveSelectionByOffset;
  },
  onKeyDownToggleElement: function onKeyDownToggleElement() {
    return _onKeyDownToggleElement;
  },
  onKeyDownToggleMark: function onKeyDownToggleMark() {
    return _onKeyDownToggleMark;
  },
  usePlateElement: function usePlateElement() {
    return _usePlateElement;
  },
  usePlateLeaf: function usePlateLeaf() {
    return _usePlateLeaf;
  }
});
module.exports = __toCommonJS(server_exports);

// src/shared/PlateElement.tsx
var import_react = __toESM(require("react"));
var import_react_utils = require("@udecode/react-utils");
var import_clsx = require("clsx");
var _usePlateElement = function _usePlateElement(props) {
  var _a = props,
    attributes = _a.attributes,
    editor = _a.editor,
    element = _a.element,
    elementToAttributes = _a.elementToAttributes,
    nodeProps = _a.nodeProps,
    rootProps = __objRest(_a, ["attributes", "editor", "element", "elementToAttributes", "nodeProps"]);
  return {
    props: __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, attributes), rootProps), nodeProps), elementToAttributes == null ? void 0 : elementToAttributes(element)), {
      className: (0, import_clsx.clsx)(props.className, nodeProps == null ? void 0 : nodeProps.className)
    }),
    ref: (0, import_react_utils.useComposedRef)(props.ref, attributes.ref)
  };
};
var _PlateElement = import_react.default.forwardRef(function (props, ref) {
  var _usePlateElement2 = _usePlateElement(__spreadProps(__spreadValues({}, props), {
      ref: ref
    })),
    rootProps = _usePlateElement2.props,
    rootRef = _usePlateElement2.ref;
  return /* @__PURE__ */import_react.default.createElement(import_react_utils.Box, __spreadProps(__spreadValues({}, rootProps), {
    ref: rootRef
  }));
});
_PlateElement.displayName = "PlateElement";

// src/shared/PlateLeaf.tsx
var import_react2 = __toESM(require("react"));
var import_react_utils2 = require("@udecode/react-utils");
var import_clsx2 = require("clsx");
var _usePlateLeaf = function _usePlateLeaf(props) {
  var _a = props,
    attributes = _a.attributes,
    editor = _a.editor,
    leaf = _a.leaf,
    leafToAttributes = _a.leafToAttributes,
    nodeProps = _a.nodeProps,
    text = _a.text,
    rootProps = __objRest(_a, ["attributes", "editor", "leaf", "leafToAttributes", "nodeProps", "text"]);
  return {
    props: __spreadProps(__spreadValues(__spreadValues(__spreadValues(__spreadValues({}, attributes), rootProps), nodeProps), leafToAttributes == null ? void 0 : leafToAttributes(leaf)), {
      className: (0, import_clsx2.clsx)(props.className, nodeProps == null ? void 0 : nodeProps.className)
    }),
    ref: (0, import_react_utils2.useComposedRef)(props.ref, attributes.ref)
  };
};
var _PlateLeaf = import_react2.default.forwardRef(function (props, ref) {
  var _usePlateLeaf2 = _usePlateLeaf(__spreadProps(__spreadValues({}, props), {
      ref: ref
    })),
    rootProps = _usePlateLeaf2.props,
    rootRef = _usePlateLeaf2.ref;
  return /* @__PURE__ */import_react2.default.createElement(import_react_utils2.Text, __spreadProps(__spreadValues({}, rootProps), {
    ref: rootRef
  }));
});
_PlateLeaf.displayName = "PlateLeaf";

// src/shared/addSelectedRow.ts
var _addSelectedRow = function _addSelectedRow(editor, id) {
  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var blockSelectionStore = editor.blockSelectionStore;
  if (blockSelectionStore) {
    blockSelectionStore.set.addSelectedRow(id, options);
  }
};

// src/shared/blockSelectedIds.ts
var _blockSelectedIds = function _blockSelectedIds(editor) {
  var blockSelectionStore = editor.blockSelectionStore;
  if (blockSelectionStore) {
    return blockSelectionStore.get.selectedIds();
  }
};

// src/shared/createNodeHOC.tsx
var import_react3 = __toESM(require("react"));
var _createNodeHOC = function _createNodeHOC(HOC) {
  return function (Component, props) {
    return function hoc(childrenProps) {
      return /* @__PURE__ */import_react3.default.createElement(HOC, __spreadValues({}, __spreadValues(__spreadValues({}, childrenProps), props)), /* @__PURE__ */import_react3.default.createElement(Component, __spreadValues({}, childrenProps)));
    };
  };
};

// src/shared/createNodesHOC.tsx
var import_castArray = __toESM(require("lodash/castArray.js"));
var import_merge = __toESM(require("lodash/merge.js"));
var createHOC = function createHOC(withHOC) {
  return function (components, options) {
    var _components = __spreadValues({}, components);
    var optionsByKey = {};
    var optionsList = (0, import_castArray.default)(options);
    optionsList.forEach(function (_a) {
      var _b = _a,
        key = _b.key,
        keys = _b.keys,
        opt = __objRest(_b, ["key", "keys"]);
      var _keys = key ? [key] : keys != null ? keys : Object.keys(_components);
      _keys.forEach(function (_key) {
        optionsByKey[_key] = (0, import_merge.default)(optionsByKey[_key], opt);
      });
    });
    Object.keys(optionsByKey).forEach(function (key) {
      if (!_components[key]) return;
      _components[key] = withHOC(_components[key], optionsByKey[key]);
    });
    return _components;
  };
};
var _createNodesHOC = function _createNodesHOC(HOC) {
  return createHOC(_createNodeHOC(HOC));
};
var _createNodesWithHOC = function _createNodesWithHOC(withHOC) {
  return createHOC(withHOC);
};

// src/shared/defaultsDeepToNodes.ts
var import_server = require("@udecode/plate-core/server");
var import_defaults = __toESM(require("lodash/defaults.js"));
var _defaultsDeepToNodes = function _defaultsDeepToNodes(options) {
  (0, import_server.applyDeepToNodes)(__spreadProps(__spreadValues({}, options), {
    apply: import_defaults.default
  }));
};

// src/shared/hasBlockSelected.ts
var _hasBlockSelected = function _hasBlockSelected(editor) {
  var ids = _blockSelectedIds(editor);
  return ids && ids.size > 0;
};

// src/shared/isBlockSelected.ts
var _isBlockSelected = function _isBlockSelected(editor, id) {
  var ids = _blockSelectedIds(editor);
  return ids == null ? void 0 : ids.has(id);
};

// src/shared/isType.ts
var import_server2 = require("@udecode/plate-core/server");
var import_castArray2 = __toESM(require("lodash/castArray.js"));
var _isType = function _isType(editor, node, key) {
  var keys = (0, import_castArray2.default)(key);
  var types = [];
  keys.forEach(function (_key) {
    return types.push((0, import_server2.getPluginType)(editor, _key));
  });
  return types.includes(node == null ? void 0 : node.type);
};

// src/shared/moveSelectionByOffset.ts
var import_server3 = require("@udecode/plate-core/server");
var import_slate = require("@udecode/slate");
var import_slate2 = require("slate");
var _moveSelectionByOffset = function _moveSelectionByOffset(editor) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
    _ref$query = _ref.query,
    query = _ref$query === void 0 ? function () {
      return true;
    } : _ref$query;
  return function (event) {
    var selection = editor.selection;
    if (!selection || import_slate2.Range.isExpanded(selection) || !query(editor)) {
      return false;
    }
    if ((0, import_server3.isHotkey)("left", event)) {
      event.preventDefault();
      (0, import_slate.moveSelection)(editor, {
        reverse: true,
        unit: "offset"
      });
      return true;
    }
    if ((0, import_server3.isHotkey)("right", event)) {
      event.preventDefault();
      (0, import_slate.moveSelection)(editor, {
        unit: "offset"
      });
      return true;
    }
  };
};

// src/shared/onKeyDownToggleElement.ts
var import_server4 = require("@udecode/plate-core/server");
var import_castArray3 = __toESM(require("lodash/castArray.js"));
var _onKeyDownToggleElement = function _onKeyDownToggleElement(editor, _ref2) {
  var hotkey = _ref2.options.hotkey,
    type = _ref2.type;
  return function (e) {
    if (e.defaultPrevented) return;
    var defaultType = (0, import_server4.getPluginType)(editor, import_server4.ELEMENT_DEFAULT);
    if (!hotkey) return;
    var hotkeys = (0, import_castArray3.default)(hotkey);
    var _iterator4 = _createForOfIteratorHelper(hotkeys),
      _step4;
    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var _hotkey = _step4.value;
        if ((0, import_server4.isHotkey)(_hotkey, e)) {
          e.preventDefault();
          (0, import_server4.toggleNodeType)(editor, {
            activeType: type,
            inactiveType: defaultType
          });
          return;
        }
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  };
};

// src/shared/onKeyDownToggleMark.ts
var import_server5 = require("@udecode/plate-core/server");
var import_slate_utils = require("@udecode/slate-utils");
var _onKeyDownToggleMark = function _onKeyDownToggleMark(editor, _ref3) {
  var _ref3$options = _ref3.options,
    clear = _ref3$options.clear,
    hotkey = _ref3$options.hotkey,
    type = _ref3.type;
  return function (e) {
    if (e.defaultPrevented) return;
    if (!hotkey) return;
    if ((0, import_server5.isHotkey)(hotkey, e)) {
      e.preventDefault();
      (0, import_slate_utils.toggleMark)(editor, {
        clear: clear,
        key: type
      });
    }
  };
};
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  PlateElement: _PlateElement,
  PlateLeaf: _PlateLeaf,
  addSelectedRow: _addSelectedRow,
  blockSelectedIds: _blockSelectedIds,
  createNodeHOC: _createNodeHOC,
  createNodesHOC: _createNodesHOC,
  createNodesWithHOC: _createNodesWithHOC,
  defaultsDeepToNodes: _defaultsDeepToNodes,
  hasBlockSelected: _hasBlockSelected,
  isBlockSelected: _isBlockSelected,
  isType: _isType,
  moveSelectionByOffset: _moveSelectionByOffset,
  onKeyDownToggleElement: _onKeyDownToggleElement,
  onKeyDownToggleMark: _onKeyDownToggleMark,
  usePlateElement: _usePlateElement,
  usePlateLeaf: _usePlateLeaf
});